import { memo, useMemo } from "react";
import Featurelist from "./FeatureProductlist/Featurelist";

function Features({ data }) {
	const featured = useMemo(() => Array.isArray(data) ? data.filter((item) => item?.images?.[0]).slice(0, 4) : [], [data]);
	return (
		<section className="overflow-x-hidden" aria-labelledby="featured-gowns-title">
			<div className="text-center mb-10 overflow-hidden">
				<h2 id="featured-gowns-title" className="text-4xl md:text-5xl font-semibold font-lora">Featured Gowns</h2>
			</div>
			<ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 mt-20 mb-16 px-4 lg:px-16 md:px-10 overflow-x-hidden">
				{featured.map((item) => <Featurelist key={item._id || item.style} data={item} />)}
			</ul>
		</section>
	);
}
export default memo(Features);
